import firebase from "firebase/app";
import _ from "lodash";
import { kDefaultProfileIconUri } from "src/util/constants";
import { tBoutique, tBrand, tLongAddress, tPromotion, tRep } from "tmt_api/src/types/types";
import { tBrandInput, tCompanyState } from "./types";

export const getDefaultLongAddress = (): tLongAddress => _.cloneDeep(kDefaultLongAddress);
export const kDefaultLongAddress: tLongAddress = {
  address1: "",
  city: "",
  country_code: "",
  first_name: "",
  last_name: "",
  postal_code: "",
  state_or_province: "",
};

export const getDefaultBrandProfile = (): tBrand => _.cloneDeep(kDefaultBrandProfile);
const kDefaultBrandProfile: tBrand = {
  id: "00000000-0000-0000-0000-000000000000",
  returnPolicy: "",
  termsAndConditions: { url: "", name: "" },
  tagLine: "",
  detail: "",
  contacts: [],
  paymentTerms: "",
  addresses: [kDefaultLongAddress],
  website: "",
  tags: [],
  openingMin: 0,
  reorderMin: 0,
  name: "",
  promotions: [],
  categories: {
    lvl0: [],
    lvl1: [],
  },
  links: {},
  tin: "",
  brandEthos: [],
  brandStory: "",
  // brandVideoURL: "",
  contactPerson: "",
  pauseMode: "",
  primaryCategory: "Other",
  shippingLeadTime: "1-3 Days",
  avatar: kDefaultProfileIconUri,
  images: {
    logoDownloadURL: kDefaultProfileIconUri,
    heroes: [
      {
        downloadURL: "",
        isPrimary: false,
      },
    ],
  },
  isExclusive: false,
  commissionFee: 0,
  serviceFee: 0,
  taxId: "",
};

export const getDefaultBrandInput = (): tBrandInput => _.cloneDeep(kDefaultBrandInput);
const kDefaultBrandInput: tBrandInput = {
  termsAndConditions: { url: "", name: "" },
  addresses: [kDefaultLongAddress],
  website: "",
  openingMin: 0,
  reorderMin: 0,
  name: "",
  links: { instagram: "", facebook: "" },
  brandEthos: [],
  brandStory: "",
  brandVideoURL: "",
  contactPerson: "",
  pauseMode: "",
  primaryCategory: "Other",
  shippingLeadTime: "",
  cityBased: "",
  images: {
    logoDownloadURL:
      "https://upload.wikimedia.org/wikipedia/commons/7/7f/Anglel_Bless_Legendary_Hills_1_m%C4%9Bs%C3%ADc_st%C3%A1%C5%99%C3%AD.jpg",
    heroes: [],
  },
};

export const getDefaultBoutiqueProfile = (): tBoutique => _.cloneDeep(kDefaultBoutiqueProfile);
export const kDefaultBoutiqueProfile: tBoutique = {
  avatar: "",
  id: "",
  name: "",
  preferredPaymentMethod: "Net30",
  termsAndConditions: { url: "", name: "" },
  status: "",
  website: "",
  // For both
  addresses: [kDefaultLongAddress],
  // For BC
  owner: {
    first_name: "",
    last_name: "",
  },
  links: {},
  email: "",
  company: "",
  phone: "",
  customer_group_id: 0,
  attributes: [],
  taxId: "",
  taxInfo: { name: "", url: "" },
};

export const getDefaultRepProfile = (): tRep => _.cloneDeep(kDefaultRepProfile);
const kDefaultRepProfile: tRep = {
  name: "",
  email: "",
  address: kDefaultLongAddress,
  socialMedia: {},
  avatar: "",
  id: "",
  dateJoined: firebase.firestore.Timestamp.now(),
  taxInfo: { name: "", url: "" },
  taxId: "",
  vendorId: "",
};

export const getDefaultCompanyState = (): tCompanyState => _.cloneDeep(kDefaultCompanyState);
const kDefaultCompanyState: tCompanyState = {
  type: "none",
};
export const getDefaultPromotions = (): tPromotion => _.cloneDeep(kDefaultPromotion);
const kDefaultPromotion: tPromotion = {
  brandId: "",
  code: "",
  enableAt: 0,
  endDate: 0,
  id: "",
  isPrivate: true,
  name: "",
  ordersApplied: [],
  startDate: 0,
  timesUsed: 0,
  deactivated: false,
  discountFixed: 0,
  discountPercent: 0,
};
